module.exports = __webpack_public_path__ + "media/images/faramia/afaq-c2b13b3fe349a7b47d3c0ca55475cb01.png";